import { BNPRegistrationType } from ".";
import { useTranslation } from "react-i18next";

export const useTranslationWithType = (type: BNPRegistrationType) => {
  const { t: tWithType } = useTranslation('registration_bnp', {
    keyPrefix: type === 'ubnp' ? 'mikro_bnp' : 'sme_bnp',
  });
  return tWithType;
};
